module.exports = __webpack_public_path__ + "static/media/medkit.6c963508.svg";